module.exports = __webpack_public_path__ + "static/media/KCS.38874320.gif";